module.exports = __webpack_public_path__ + "dimer/static/img/24.b9bcb53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/globalPartner/24.jpg
// module id = u2oZ
// module chunks = 0